import { Link } from 'react-router-dom';
import developerPhoto from '../assets/developer-photo.jpg';

function AboutPage() {
  return (
    <div className="py-12 bg-slate-50">
      <div className="container mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12 glow-text">About Family Dashboard</h1>
        
        <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-lg overflow-hidden mb-12">
          <div className="md:flex">
            <div className="md:flex-shrink-0">
              <img 
                className="h-48 w-full object-cover md:w-48" 
                src={developerPhoto} 
                alt="Developer Alex Young" 
              />
            </div>
            <div className="p-8">
              <h2 className="text-2xl font-bold mb-4">The Developer</h2>
              <p className="mb-4">
                Family Dashboard was created by Ryken Labs, a software development company focused on family-oriented technology solutions. The application was born from a personal need to centralize family information in one easily accessible place.
              </p>
              <p>
                What started as a small project for personal use has grown into an application that I hope can help other families stay organized and connected.
              </p>
            </div>
          </div>
        </div>
        
        <div className="max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Contact Information */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold mb-4">Contact Information</h2>
              <p className="mb-6">
                Have questions, suggestions, or feedback? I'd love to hear from you!
              </p>
              
              <div className="space-y-4">
                <div>
                  <h3 className="font-semibold mb-1">Email</h3>
                  <p className="text-blue-600">info@rykenlabs.com</p>
                </div>
              </div>
            </div>
            
            {/* FAQ Section */}
            <div className="bg-white rounded-lg shadow-md p-8">
              <h2 className="text-2xl font-bold mb-4">Frequently Asked Questions</h2>
              
              <div className="space-y-6">
                <div>
                  <h3 className="font-semibold mb-1">Is Family Dashboard free to use?</h3>
                  <p>
                    Yes! Family Dashboard is currently free for personal use. We may introduce paid features in the future, but the core functionality will remain free.
                  </p>
                </div>
                
                <div>
                  <h3 className="font-semibold mb-1">How do I install Family Dashboard?</h3>
                  <p>
                    Family Dashboard is currently in development. Once released, installation instructions will be provided on this website.
                  </p>
                </div>
                
                <div>
                  <h3 className="font-semibold mb-1">What data access permissions do I need to grant?</h3>
                  <p>
                    Family Dashboard requires read-only access to your Google Calendar. Photos come from your own phone or a local folder — no Google access needed. We never modify your data or store it on our servers.
                  </p>
                </div>
                
                <div>
                  <h3 className="font-semibold mb-1">Can I customize the dashboard?</h3>
                  <p>
                    Yes! Family Dashboard offers customization options including which calendars to display, weather location, which photos to show, and more.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Google Cloud Verification Info */}
          <div className="bg-blue-900 text-white rounded-lg shadow-md p-8 mt-8">
            <h2 className="text-2xl font-bold mb-4">Google API Usage Information</h2>
            <p className="mb-4">
              Family Dashboard uses one Google API. Here's how we use it:
            </p>

            <div className="space-y-4">
              <div>
                <h3 className="text-xl font-semibold mb-2">Google Calendar API</h3>
                <ul className="list-disc pl-5 space-y-1">
                  <li>Used to display your calendar events</li>
                  <li>Read-only access to event data</li>
                  <li>No modification of your calendar</li>
                  <li>No persistent storage of calendar data</li>
                </ul>
              </div>
            </div>
            
            <p className="mt-6">
              We take your privacy seriously. Read our <Link to="/privacy" className="text-blue-300 hover:underline">Privacy Policy</Link> and <Link to="/terms" className="text-blue-300 hover:underline">Terms of Service</Link> for more information.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;